import React from "react";
import { useLocaleContext } from "../../context/LocaleContext";
import ButtonQuestionWriteFormWrapper from "../../components/QuestionMessages/ButtonQuestionWriteFormWrapper";
import MenuIcons from "../../components/Icons/IconPackage/MenuIcons";
import { useNavigate } from "react-router-dom";
import { useEventContext } from "../../context/EventContext";
import { ModalContextProvider } from "../../context/ModalContext";
import './style.scss';

const getButtons = (blockProperties) => {
    const _buttons = blockProperties.buttons || [];
    const programButton = blockProperties.programButton || {};
    const questionButton = blockProperties.questionButton || {};
    if (programButton.enabled && !_buttons.find(({id}) => id === 10000)) {
        _buttons.push({
            id: 10000,
            type: 'navigationInner',
            actionType: '',
            navigateTo: 'program',
            textRu: programButton.textRu || '',
            textEn: programButton.textEn || '',
            accentColor: programButton.accentColor,
        })
    }
    if (questionButton.enabled && !_buttons.find(({id}) => id === 10001)) {
        _buttons.push({
            id: 10001,
            type: 'action',
            actionType: 'askQuestion',
            navigateTo: '',
            textRu: questionButton.textRu || '',
            textEn: questionButton.textEn || '',
            accentColor: questionButton.accentColor,
        })
    }
    return _buttons.sort((a, b) => a.order - b.order).map((button, idx) => ({ ...button, order: idx + 1 }))
}

const NavigationButton = ({ button, watchKey, navigationInner }) => {
    const navigate = useNavigate();
    const { getProperty } = useLocaleContext();

    return <button
        className={`question-message-write-button ${button.accentColor ? 'question-message-write-button--accent' : ''}`}
        onClick={() => navigationInner ? navigate(`/event/${watchKey}/${button.navigateTo}`) : window.open(button.navigateTo)}
    >
        {navigationInner && <MenuIcons type={button.navigateTo} />}
        <span>{getProperty(button, 'text')}</span>
    </button>
}

export default ({ block }) => {
    const { watchKey } = useEventContext();
    const { getProperty } = useLocaleContext();

    const buttons = getButtons(block || {});

    const actionButtonTemplates = {
        askQuestion: (button) => <ButtonQuestionWriteFormWrapper key={button.id} title={getProperty(button, 'text')} selectStream={null} settings={{ askQuestionAccentStyle: button.accentColor }} />
    }

    const buttonTemplates = {
        action: (button) => actionButtonTemplates[button.actionType] ? actionButtonTemplates[button.actionType](button) : actionButtonTemplates['askQuestion'](button),
        navigationInner: (button) => <NavigationButton key={button.id} button={button} watchKey={watchKey} navigationInner />,
        navigationOuter: (button) => <NavigationButton key={button.id} button={button} watchKey={watchKey} />
    }

    if (!buttons.length) return null;

    return (
        <section className={"page-block button-block"}>
            <ModalContextProvider>
                {buttons.map(button => buttonTemplates[button.type](button))}
            </ModalContextProvider>
        </section>
    );
}
